import { render, staticRenderFns } from "./boxModal.vue?vue&type=template&id=723145b6"
import script from "./boxModal.vue?vue&type=script&lang=js"
export * from "./boxModal.vue?vue&type=script&lang=js"
import style0 from "./boxModal.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports